import { Price } from '@spartacus/core';

export type CustomerPrice = {
  productCode?: string;
  customerPrice?: Price;
  listPrice?: Price;
  discount?: number;
};

export type CustomerPriceError = {
  productCode?: string;
  errorType?: PRICE_ERROR_TYPE;
  messageKey?: string;
};

export enum PRICE_ERROR_TYPE {
  GENERIC_ERROR,
  NOT_ALLOWED_ERROR
}
